import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="text-white py-5 text-center">
      <div className="nf-wrap">
        <div className="nf-badge mb-3" aria-hidden>🍕</div>
        <h1 className="fw-bold mb-2">404 — Lost your slice?</h1>
        <h3 className="text-white mb-4">The page you're after isn’t in the oven.</h3>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Go Back
          </Button>

          <Button variant="outline-light" onClick={() => navigate("/")}>
            Home
          </Button>
        </div>

        <h5 className="text-white mt-4 mb-0">
          Think this is a mistake?{" "}
          <a
            className="text-white text-decoration-underline"
            href="mailto:bartollinipizza@gmail.com?subject=Broken link"
          >
            Email us
          </a>
          .
        </h5>
      </div>
    </Container>
  );
};

export default NotFound;
